var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"symbols-list"},[_c('div',{staticClass:"row"},_vm._l((_vm.symbols),function(symbol){return _c('SymbolsChipsListItem',{key:symbol.alias,class:{active: symbol.id === _vm.chartActive},attrs:{"symbol":symbol},nativeOn:{"click":function($event){return _vm.makeActive(symbol.id)}}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }